"use client";
import React from "react";
import { motion } from "framer-motion";
const AnimationTitle: React.FC = () => {
  return (
    <>
      <motion.h1
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, delay: 0.1 }}
        className="whitespace-nowrap"
      >
        Dúvidas
      </motion.h1>
      <motion.h2
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, delay: 0.2 }}
        className="whitespace-nowrap"
      >
        frequentes
      </motion.h2>
    </>
  );
};

export default AnimationTitle;
